import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { Hero } from '../sections/Hero';
import { CredentialsBand } from '../sections/CredentialsBand';
import { Story } from '../sections/Story';
import { Strengths } from '../sections/Strengths';
import { Timeline } from '../sections/Timeline';
import { Testimonials } from '../sections/Testimonials';
import { ClosingCta } from '../sections/ClosingCta';

export default function Home() {
  // Bare brand on the home page, as the old layout did.
  useDocumentTitle();

  return (
    <>
      <Hero />
      <CredentialsBand />
      <Story />
      <Strengths />
      <Timeline />
      <Testimonials />
      <ClosingCta />
    </>
  );
}
